export default {
  install (Vue) {
    // eslint-disable-next-line no-param-reassign
    Vue.prototype.$liff = window.liff
  }
}
